import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, IconButton, Tooltip } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { Outlet, Link as RouterLink, useLocation } from 'react-router-dom';
import { signOut } from '../firebase';
import { useAuth } from '../auth/AuthGate';

/** App chrome: top bar (brand, home, user, sign-out) + routed page area. */
export default function Layout() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const onHome = pathname === '/';

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppBar position="sticky" color="default" elevation={1}>
        <Toolbar sx={{ gap: 2 }}>
          <Typography
            variant="h6"
            component={RouterLink}
            to="/"
            sx={{ textDecoration: 'none', color: 'inherit', flexGrow: 1 }}
          >
            Emmerson Gray Admin
          </Typography>
          {!onHome && (
            <Button component={RouterLink} to="/" size="small">
              Home
            </Button>
          )}
          <Typography variant="body2" color="text.secondary">
            {user?.email}
          </Typography>
          <Tooltip title="Settings" arrow>
            <IconButton component={RouterLink} to="/settings" size="small">
              <SettingsIcon />
            </IconButton>
          </Tooltip>
          <Button
            variant="outlined"
            size="small"
            onClick={() => signOut().then(() => window.location.reload())}
          >
            Sign out
          </Button>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
